<div class="business-info">
  <div class="paddnig-left-desk">
    <div>
      <div>
        <div class="pl-md-0 ">
          <div
            class="nav nav-tabs nav-fill"
            id="nav-tab"
            role="tablist"
            *ngIf="tabsMenu"
          >
            <a
              class="nav-item nav-link active col-3"
              id="nav-home-tab"
              data-toggle="tab"
              href="#nav-home"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              (click)="clickNavBar('yearToDate')"
              >{{ tabsMenu[0].displayItems[0].keyText }}</a
            >
            <a
              class="nav-item nav-link col-3"
              id="nav-profile-tab"
              data-toggle="tab"
              href="#nav-profile"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false"
              (click)="clickNavBar('pastSixMonth')"
              >{{ tabsMenu[0].displayItems[1].keyText }}</a
            >
            <a
              class="nav-item nav-link col-3"
              id="nav-contact-tab"
              data-toggle="tab"
              href="#nav-contact"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false"
              (click)="clickNavBar('pastYear')"
              >{{ tabsMenu[0].displayItems[2].keyText }}</a
            >

            <a
              class="nav-item nav-link col-3"
              id="nav-dateFrom-tab"
              data-toggle="tab"
              href="#nav-dateFrom"
              role="tab"
              aria-controls="nav-dateFrom"
              aria-selected="false"
              (click)="getCustomPage('custom')"
            >
              {{ tabsMenu[0].displayItems[3].keyText }}
            </a>
          </div>
        </div>
        <!-- <ac-tabs></ac-tabs> -->
      </div>
      <div class="row tab-loader" *ngIf="tabloading">
        <div class="loader"></div>
      </div>
      <div
        class="tab-content py-3 px-sm-0"
        id="nav-tabContent"
        *ngIf="tabsContentLabel"
      >
        <ng-container *ngIf="this.showComponent == 'yearToDate' && !tabloading">
          <!-- <ac-yeartodate></ac-yeartodate> -->
          <div
            class="tab-pane fade show active"
            id="nav-home"
            role="tabpanel"
            aria-labelledby="nav-home-tab"
          >
            <div class="row d-flex bot-spacing60">
              <div class="col-6 col-sm-4">
                <p class="sub-div">
                  {{ tabsContentLabel[0].displayItems[0].keyText }}
                </p>
                <span class="business-no">{{ submissionCount }}</span>
              </div>
              <div class=" col-6 col-sm-4">
                <p class="sub-div">
                  {{ tabsContentLabel[0].displayItems[1].keyText }}
                </p>
                <span class="business-no">{{ quotedCount }}</span>
              </div>
              <div class="col-6 col-sm-4">
                <p class="sub-div">
                  {{ tabsContentLabel[0].displayItems[2].keyText }}
                </p>
                <span class="business-no"
                  >{{ ratio | gridCellFormatter: 'currency' }}%</span
                >
              </div>

              <div class="col-6 col-sm-4" *ngIf="this.globalVarService.isWrittenCommissionDisplayApplicable == 'Y'" >
                <p class="sub-div">
                  {{ tabsContentLabel[0].displayItems[3].keyText }}
                </p>
                <span class="business-no">{{ claimPaid | currency }}</span>
              </div>
              <div class="col-6 col-sm-4">
                <p class="sub-div">
                  {{ tabsContentLabel[0].displayItems[4].keyText }}
                </p>
                <span class="business-no">{{ gwpAmt | currency }}</span>
              </div>
              <div class="col-6 col-sm-4">
                <p class="sub-div">
                  {{ tabsContentLabel[0].displayItems[5].keyText }}
                </p>
                <span class="business-no"
                  >{{ commissionPaid | gridCellFormatter: 'currency' }}%</span
                >
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container
          *ngIf="this.showComponent == 'pastSixMonth' && !tabloading"
        >
          <div
            class="tab-pane fade"
            id="nav-profile"
            role="tabpanel"
            aria-labelledby="nav-profile-tab"
          >
            <div
              class="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div class="row d-flex bot-spacing60">
                <div class="col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[0].keyText }}
                  </p>
                  <span class="business-no">{{ submissionCount }}</span>
                </div>
                <div class=" col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[1].keyText }}
                  </p>
                  <span class="business-no">{{ quotedCount }}</span>
                </div>
                <div class="col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[2].keyText }}
                  </p>
                  <span class="business-no"
                    >{{ ratio | gridCellFormatter: 'currency' }}%</span
                  >
                </div>

                <div class="col-6 col-sm-4" *ngIf="this.globalVarService.isWrittenCommissionDisplayApplicable == 'Y'" >
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[3].keyText }}
                  </p>
                  <span class="business-no">{{ claimPaid | currency }}</span>
                </div>
                <div class="col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[4].keyText }}
                  </p>
                  <span class="business-no">{{ gwpAmt | currency }}</span>
                </div>
                <div class="col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[5].keyText }}
                  </p>
                  <span class="business-no"
                    >{{ commissionPaid | gridCellFormatter: 'currency' }}%</span
                  >
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="this.showComponent == 'pastYear' && !tabloading">
          <div
            class="tab-pane fade"
            id="nav-contact"
            role="tabpanel"
            aria-labelledby="nav-contact-tab"
          >
            <div
              class="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div class="row d-flex bot-spacing60">
                <div class="col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[0].keyText }}
                  </p>
                  <span class="business-no">{{ submissionCount }}</span>
                </div>
                <div class=" col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[1].keyText }}
                  </p>
                  <span class="business-no">{{ quotedCount }}</span>
                </div>
                <div class="col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[2].keyText }}
                  </p>
                  <span class="business-no"
                    >{{ ratio | gridCellFormatter: 'currency' }}%</span
                  >
                </div>

                <div class="col-6 col-sm-4" *ngIf="this.globalVarService.isWrittenCommissionDisplayApplicable == 'Y'" >
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[3].keyText }}
                  </p>
                  <span class="business-no">{{ claimPaid | currency }}</span>
                </div>
                <div class="col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[4].keyText }}
                  </p>
                  <span class="business-no">{{ gwpAmt | currency }}</span>
                </div>
                <div class="col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[5].keyText }}
                  </p>
                  <span class="business-no"
                    >{{ commissionPaid | gridCellFormatter: 'currency' }}%</span
                  >
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="this.showComponent == 'custom' && !tabloading">
          <div
            class="tab-pane fade"
            id="nav-dateFrom"
            role="tabpanel"
            aria-labelledby="nav-dateFrom-tab"
          >
            <div
              class="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div class="row customtab d-flex">
                <form [formGroup]="frmGroup" class="form-row mt-3">
                  <div class="col-6 col-sm-4">
                    <hcc-datepicker-input
                      [control]="dateFromConfig.fieldInfo.fieldName"
                      [frmGroup]="frmGroup"
                      [fieldInfo]="dateFromConfig.fieldInfo"
                      [InputConfig]="dateFromConfig.config"
                      [placeholder]="dateFromConfig.fieldInfo.placeholder"
                      class="fromDate"
                    >
                    </hcc-datepicker-input>
                  </div>
                  <div class="col-6 col-sm-4">
                    <hcc-datepicker-input
                      [control]="dateToConfig.fieldInfo.fieldName"
                      [frmGroup]="frmGroup"
                      [fieldInfo]="dateToConfig.fieldInfo"
                      [InputConfig]="dateToConfig.config"
                      [placeholder]="dateToConfig.fieldInfo.placeholder"
                      class="toDate"
                    >
                    </hcc-datepicker-input>
                  </div>
                  <div class="col-6 col-sm-4">
                    <button
                      type="button"
                      id="create-new-claim-btn"
                      class="btn btn-primary w-100"
                      (click)="searchKpi()"
                    >
                      Search
                    </button>
                  </div>
                </form>
              </div>
              <div class="row d-flex bot-spacing60">
                <div class="col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[0].keyText }}
                  </p>
                  <span class="business-no">{{ submissionCount }}</span>
                </div>
                <div class=" col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[1].keyText }}
                  </p>
                  <span class="business-no">{{ quotedCount }}</span>
                </div>
                <div class="col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[2].keyText }}
                  </p>
                  <span class="business-no"
                    >{{ ratio | gridCellFormatter: 'currency' }}%</span
                  >
                </div>

                <div class="col-6 col-sm-4" *ngIf="this.globalVarService.isWrittenCommissionDisplayApplicable == 'Y'" >
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[3].keyText }}
                  </p>
                  <span class="business-no">{{ claimPaid | currency }}</span>
                </div>
                <div class="col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[4].keyText }}
                  </p>
                  <span class="business-no">{{ gwpAmt | currency }}</span>
                </div>
                <div class="col-6 col-sm-4">
                  <p class="sub-div">
                    {{ tabsContentLabel[0].displayItems[5].keyText }}
                  </p>
                  <span class="business-no"
                    >{{ commissionPaid | gridCellFormatter: 'currency' }}%</span
                  >
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="row mt-4 customBtn">
          <!-- <div class="col-md-6">
            <button
              type="button"
              id="create-new-claim-btn"
              class="btn btn-primary w-100"
            >
              AGENCY LOSS RUN
            </button>
          </div> -->
          <!-- <div class="col-md-6">
            <button
              type="button"
              id="search-for-claim-btn"
              class="btn btn-primary w-100"
            >
              BOUND POLICIES REPORT
            </button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
